import languageConstants from '../../constants/language-constants';
import callPrompts from '../../services/api/CallPrompts';
import subscriptionFilters from '../../services/api/Filters';
import {
  CREATE_PROMPT_SAVE_ACTION, UPDATE_PROMPT_SAVE_ACTION, PROMPT_FILTER_LIST_LOAD_ACTION, PROMPT_LOAD_BY_ID_ACTION, PROMPT_ARCHIVE_ACTION,
  PROMPT_CONVERT_TEXT_TO_VOICE_ACTION, PROMPT_AUDIO_BY_PROMPT_ID_ACTION, UPDATE_USED_PROMPT_ACTION,
  PROMPT_LIST_LOAD_ACTION, PROMPT_LANGUAGE_LIST_LOAD_ACTION,
  PROMPT_VOICE_LIST_LOAD_ACTION, PROMPT_DROPDOWNS_API_LOAD_ACTION
} from '../action-types';

import {
  PROMPT_ARCHIVE_MUTATION, PROMPT_SCRIPT_LANGUAGE_CHANGE_MUTATION, PROMPT_SAVE_BUTTON_DISABLE_CHANGE_MUTATION,
  PROMPT_CREATE_TO_EDIT_MUTATION, PROMPT_CLEAR_DATA_MUTATION, PROMPT_FILTER_LIST_LOAD_MUTATION,
  PROMPT_LOAD_BY_ID_MUTATION, PROMPT_NAME_CHANGE_MUTATION, PROMPT_TYPE_CHANGE_MUTATION, PROMPT_VOICE_LIST_LOAD_MUTATION,
  PROMPT_LANGUAGE_LIST_LOAD_MUTATION, PROMPT_LIST_LOAD_MUTATION,
  PROMPT_STATUS_CHANGE_MUTATION, PROMPT_UNKNOWN_CONCIERGE_PROMPT_SCRIPT_CHANGE_MUTATION, PROMPT_SCRIPT_VOICE_CHANGE_MUTATION,
  PROMPT_KNOWN_CONCIERGE_PROMPT_SCRIPT_CHANGE_MUTATION, PROMPT_SCRIPT_CHANGE_MUTATION, PROMPT_SCRIPT_SPEED_CHANGE_MUTATION,
  PROMPT_PRESS_SAY_ADD_ROW_MUTAION, PROMPT_PRESS_SAY_REMOVE_MUTATION, PROMPT_PRESS_SAY_CHANGE_MUTATION, PROMPT_AUDIO_DURATION_CHANGE_MUTATION,
  PROPMT_SUBSCRIPTION_FILTER_TYPE_ID_CHANGE_MUTATION, PROMPT_INPUT_LENGTH_CHANGE_MUTATION, PROMPT_PARAMETER_ADD_ROW_MUTATION,
  PROMPT_PARAMETER_DIAL_TYPE_CHANGE_MUTATION, PROMPT_LOGIC_TYPE_PARAMETER_CHANGE_MUTATION, PROMPT_LOGIC_TYPE_CHANGE_MUTATION,
  PROMPT_SCRIPT_ENABLE_CHANGE_MUTATION, PROMPT_UPDATE_FILTER_CONNECTION_MODEL, PROMPT_AUDIT_LOG_MUTATION,
  PROMPT_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION, PROMPT_DROPDOWNS_API_MUTAION, PROMPT_FILTER_LIST_CLEAR_DATA_MUTATION, PROMPT_WEBHOOK_PARAMETER_CHANGE_MUTATION} from '../mutation-types';

import commonFunctions from '../../mixin/common-function-mixins';
export const namespaced = true;

// initial state
export const state = {
  namespaced: true,
  promptList: null,
  promptLanguageList: null,
  promptVoiceList: null,
  promptFilterList: null,
  dialTypes: [{ 'dialId': 1, 'dialName': 'Sip', 'dialValue': 'Sip' }, { 'dialId': 2, 'dialName': 'Number', 'dialValue': 'Number' }],
  promptData: getEmptyPrompt(),
  isPromptCreateToEdit: false,
  isPromptScriptEnabled: false,
  saveButtonDisable: false,
  filterConnectionModel: [],
  oldPromptData:null,
  promptDropDowns: null
};

// mutations
export const mutations = {
  [PROMPT_CREATE_TO_EDIT_MUTATION](state, payLoad) {
    state.isPromptCreateToEdit = payLoad.isPromptCreateToEdit;
    if (payLoad.isPromptCreateToEdit) state.promptData = payLoad.response
  },
  [PROMPT_CLEAR_DATA_MUTATION](state) {
    state.promptData = getEmptyPrompt();
  },
  //New Mutations
  [PROMPT_LANGUAGE_LIST_LOAD_MUTATION](state, promptLanguageList) {
    const languages = promptLanguageList.filter(r => r.languageValue != languageConstants.ENGLISH_INDIAN && r.languageValue != languageConstants.ENGLISH_AUSTRALIAN);
    var promptLanguages = commonFunctions.methods.sortRecords(languages, 'languageName', true);
    state.promptLanguageList = promptLanguages;
  },
  [PROMPT_LIST_LOAD_MUTATION](state, promptList) {
    state.promptList = promptList;
  },
  [PROMPT_ARCHIVE_MUTATION](state, payload) {
    var index = state.promptList.findIndex(row => row.promptID == payload.promptID);
    if (index != -1) state.promptList[index].statusName = 'Archive';
    return state.promptList;
  },
  [PROMPT_LOAD_BY_ID_MUTATION](state, prompt) { // 3 is dialtype, 14 is logic
    if(prompt.promptParameters && prompt.promptParameters.length > 0 && (prompt.promptTypeID == 3 || prompt.promptTypeID == 14)) {
      var Index = 0;
      prompt.promptParameters.map((p) => {
        p.promptLogicIndex = Index;
        Index++;
      });
    }
    if(prompt.promptConnectionModels && prompt.promptConnectionModels.length > 0) {
      var pressSayIndex = 0;
      prompt.promptConnectionModels.map((p) => {
        p.pressSayIndex = pressSayIndex;
        pressSayIndex++;
      })
    }
    if(prompt.promptID && prompt.promptTypeID == 14 && prompt.promptParameters.length == 0){
      prompt.promptParameters = [getEmptyPromptParameters()];
    }
    state.promptData = prompt;
    if(state.promptData.callPaths.length > 0)
      state.promptData.callPaths = commonFunctions.methods.sortRecords(state.promptData.callPaths, 'statusName', true);
    state.oldPromptData = JSON.parse(JSON.stringify(prompt));
  },
  [PROMPT_NAME_CHANGE_MUTATION](state, value) {
    state.promptData.promptName = value;
  },
  [PROMPT_FILTER_LIST_LOAD_MUTATION](state, promptFilterList) {
    var promptFilters = commonFunctions.methods.sortRecords(promptFilterList, 'subscriptionFilterTypeName', true);
    state.promptFilterList = promptFilters;
  },
  [PROMPT_TYPE_CHANGE_MUTATION](state, value) {
    state.promptData.promptTypeName = null;
    state.promptData.promptTypeID = value;
    if(state.promptData.promptTypeID)
      state.promptData.promptTypeName = state.promptDropDowns.promptsTypes.filter(r => r.promptTypeID == state.promptData.promptTypeID)[0].promptTypeName;
    state.promptData.subscriptionFilterTypeID = '';
    state.promptData.promptConnectionModels = [getEmptyPromptConnectionModel()];
    state.promptData.promptParameters = [];
    if(state.promptData.promptTypeID == 14)
      state.promptData.promptParameters = [getEmptyPromptParameters()];
    if(state.promptData.promptTypeID == 3)
      state.promptData.promptParameters = getDialEmptyPromptParameters();
    if(state.promptData.promptTypeID == 15) {
      state.promptData.promptParameters = getWebhookEmptyPromptParameters();
      // Webhook prompts need Success/Failure connections
      state.promptData.promptConnectionModels = [
        { promptConnectionID: 0, promptID: state.promptData.promptID, press: 1, say: 'Success', pressSayIndex: 0 },
        { promptConnectionID: 0, promptID: state.promptData.promptID, press: 0, say: 'Failure', pressSayIndex: 1 }
      ];
    }

    state.promptData.logicTypeID = "";
    state.promptData.inputLength = '';
  },
  [PROMPT_VOICE_LIST_LOAD_MUTATION](state, promptVoiceList) {
    state.promptVoiceList = promptVoiceList;
  },
  [PROMPT_STATUS_CHANGE_MUTATION](state, value) {
    state.promptData.statusID = value;
  },
  [PROMPT_UNKNOWN_CONCIERGE_PROMPT_SCRIPT_CHANGE_MUTATION](state, value) {
    state.promptData.unKnownConciergePromptScript = value;
  },
  [PROMPT_KNOWN_CONCIERGE_PROMPT_SCRIPT_CHANGE_MUTATION](state, value) {
    state.promptData.knownConciergePromptScript = value;
  },
  [PROMPT_SCRIPT_CHANGE_MUTATION](state, value) {
    state.promptData.promptScript = value;
  },
  [PROMPT_SCRIPT_VOICE_CHANGE_MUTATION](state, value) {
    state.promptData.voice = value;
  },
  [PROMPT_SCRIPT_SPEED_CHANGE_MUTATION](state, value) {
    state.promptData.speed = value;
  },
  [PROMPT_SCRIPT_LANGUAGE_CHANGE_MUTATION](state, value) {
    state.promptData.language = value;
    state.promptData.voice = '';
  },
  [PROMPT_PRESS_SAY_CHANGE_MUTATION](state, payload) {
    state.promptData.promptConnectionModels = state.promptData.promptConnectionModels.map((p) => {
      if (p.pressSayIndex == payload.pressSayIndex) {
        return Object.assign({}, p, payload);
      }
      return p;
    });
  },
  [PROMPT_PRESS_SAY_REMOVE_MUTATION](state, pressSayIndex) {
    state.promptData.promptConnectionModels.splice(pressSayIndex, 1);
    state.promptData.promptConnectionModels.map((model, index) => { model.pressSayIndex = index; });
  },
  [PROMPT_PRESS_SAY_ADD_ROW_MUTAION](state, payload) {
    state.promptData.promptConnectionModels.push(payload);
  },
  [PROMPT_AUDIO_DURATION_CHANGE_MUTATION](state, value) {
    state.promptData.duration = value
  },
  [PROPMT_SUBSCRIPTION_FILTER_TYPE_ID_CHANGE_MUTATION](state, value) {
    state.promptData.inputLength = '';
    state.promptData.subscriptionFilterTypeID = value;
    state.promptData.promptConnectionModels = [];
    if(state.promptFilterList && state.promptFilterList.length > 0) {
      let categoricalConnectionModel = state.promptFilterList.filter(r => r.subscriptionFilterTypeID == value && r.categoricalValueModelList && r.categoricalValueModelList.length > 0);
      state.filterConnectionModel = categoricalConnectionModel;
    }
  },
  [PROMPT_UPDATE_FILTER_CONNECTION_MODEL](state, categoricalConnectionModel){
    state.filterConnectionModel = categoricalConnectionModel;
  },
  [PROMPT_INPUT_LENGTH_CHANGE_MUTATION](state, value) {
    state.promptData.inputLength = value;
  },
  [PROMPT_PARAMETER_ADD_ROW_MUTATION](state, payload) {
    state.promptData.promptParameters.push(payload);
  },
  [PROMPT_PARAMETER_DIAL_TYPE_CHANGE_MUTATION](state, payload) {
    var isDialTypeChanged = false;
    state.promptData.promptParameters.map((p) => {
      if (p.promptLogicIndex == payload.item.promptLogicIndex) {
        if(p.parameterValue != payload.value) isDialTypeChanged = true;
        p.parameterValue = payload.value
      } else {
        if(isDialTypeChanged) p.parameterValue = '';
      }
    });
  },
  [PROMPT_LOGIC_TYPE_PARAMETER_CHANGE_MUTATION](state, payload) {
    state.promptData.promptParameters.map((p) => {
      if (p.promptLogicIndex == payload.promptLogicIndex)
        p[payload.columnName] = payload.value
    });
  },
  [PROMPT_LOGIC_TYPE_CHANGE_MUTATION](state, value) {
    state.promptData.logicTypeID = value;
  },
  [PROMPT_SAVE_BUTTON_DISABLE_CHANGE_MUTATION](state, value) {
    state.saveButtonDisable = value;
  },
  [PROMPT_SCRIPT_ENABLE_CHANGE_MUTATION](state, value) {
    state.isPromptScriptEnabled = value;
  },
  [PROMPT_AUDIT_LOG_MUTATION](state, payLoad){
    state.promptData.tazClientAuditLog = payLoad;
  },
  [PROMPT_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION](state) {
    state.oldPromptData = null
  },
  [PROMPT_DROPDOWNS_API_MUTAION](state, promptDropDowns){
    if(promptDropDowns && promptDropDowns.logicTypes && promptDropDowns.logicTypes.length > 0){
      promptDropDowns.logicTypes = commonFunctions.methods.sortRecords(promptDropDowns.logicTypes, 'logicTypeName', true)
    }
    if(promptDropDowns && promptDropDowns.languages && promptDropDowns.languages.length > 0){
      const languages = promptDropDowns.languages.filter(r => r.languageValue != languageConstants.ENGLISH_INDIAN && r.languageValue != languageConstants.ENGLISH_AUSTRALIAN);
      promptDropDowns.languages = commonFunctions.methods.sortRecords(languages, 'languageName', true);
    }
    state.promptDropDowns = promptDropDowns
  },
  [PROMPT_FILTER_LIST_CLEAR_DATA_MUTATION](state) {
    state.promptFilterList = null;
  },
  [PROMPT_WEBHOOK_PARAMETER_CHANGE_MUTATION](state, payload) {
    const paramIndex = state.promptData.promptParameters.findIndex(
      function(p) { return p.parameterName && p.parameterName.toLowerCase() === payload.parameterName.toLowerCase(); }
    );
    if (paramIndex !== -1) {
      state.promptData.promptParameters[paramIndex].parameterValue = payload.parameterValue;
    } else {
      state.promptData.promptParameters.push({
        promptParameterID: 0,
        promptID: state.promptData.promptID,
        promptLogicIndex: state.promptData.promptParameters.length,
        parameterName: payload.parameterName,
        parameterValue: payload.parameterValue
      });
    }
  },

};

// actions
export const actions = {
  async [PROMPT_ARCHIVE_ACTION]({ commit }, payLoad) {
    state.promptData = payLoad.prompt;
    state.promptData.tazClientAuditLog = payLoad.tazClientAuditLog;
    const response = await callPrompts.archivePrompt(state.promptData);
    commit(PROMPT_ARCHIVE_MUTATION, response.data);
    return response.data;
  },
  async [PROMPT_CONVERT_TEXT_TO_VOICE_ACTION](state, prompt) {
    var script;
    if(Array.isArray(prompt.promptScript))
      script = prompt.promptScript.join();
    else
      script = (prompt.promptScript && prompt.promptScript.length > 0) ? prompt.promptScript : '';
    var promptDetails = {
      voiceScript: script,
      language: prompt.language,
      voice: prompt.voice,
      speed: prompt.speed,
    }
    const response = await callPrompts.convertTextToVoice(promptDetails);
    return response.data;
  },
  async [PROMPT_AUDIO_BY_PROMPT_ID_ACTION](state, promptID) {
    const response = await callPrompts.getPromptAudioByID(promptID);
    return response.data;
  },
  async [UPDATE_USED_PROMPT_ACTION]({commit}, prompt) {
    const response = await callPrompts.UpdateUsedPrompt(prompt);
    commit(PROMPT_LOAD_BY_ID_MUTATION, response.data);
    return response.data;
  },
  //New actions
  async [PROMPT_DROPDOWNS_API_LOAD_ACTION] ({commit}) {
    const promptDropDowns = await callPrompts.getPromptDropDowns();
    commit(PROMPT_DROPDOWNS_API_MUTAION, promptDropDowns.data);
    return {promptDropDowns};
  },

  async [PROMPT_LANGUAGE_LIST_LOAD_ACTION]({ commit }) {
    const response = await callPrompts.getLanguages();
    commit(PROMPT_LANGUAGE_LIST_LOAD_MUTATION, response.data);
    return response;
  },
  async [PROMPT_LIST_LOAD_ACTION]({ commit }) {
    const response = await callPrompts.getPrompts();
    commit(PROMPT_LIST_LOAD_MUTATION, response.data);
    return response;
  },
  async [PROMPT_LOAD_BY_ID_ACTION]({ commit }, promptID) {
    const response = await callPrompts.getPromptByID(promptID);
    commit(PROMPT_LOAD_BY_ID_MUTATION, response.data);
    return response.data;
  },
  async [PROMPT_FILTER_LIST_LOAD_ACTION]({ commit }) {
    const response = await subscriptionFilters.getFilters();
    commit(PROMPT_FILTER_LIST_LOAD_MUTATION, response.data);
    return response.data;
  },
  async [PROMPT_VOICE_LIST_LOAD_ACTION]({ commit }) {
    const response = await callPrompts.getVoices();
    commit(PROMPT_VOICE_LIST_LOAD_MUTATION, response.data);
    return response.data;
  },
  async [CREATE_PROMPT_SAVE_ACTION]({commit}, prompt) {
    prompt.inputLength = (prompt.inputLength) ? prompt.inputLength : 1;
    const response = await callPrompts.creartPrompt(prompt);
    commit(PROMPT_LOAD_BY_ID_MUTATION, response.data);
    return response;
  },
  async [UPDATE_PROMPT_SAVE_ACTION]({commit}, prompt) {
    prompt.inputLength = (prompt.inputLength) ? prompt.inputLength : 1;
    const response = await callPrompts.updatePrompt(prompt);
    commit(PROMPT_LOAD_BY_ID_MUTATION, response.data);
    return response.data;
  },
};

//getters
export const getters = {
  getListOfFiltersNotAllowXmlAndCampaign: state => {
    if (state.promptFilterList)
      return state.promptFilterList.filter(r => r.filterType.toUpperCase() != "XML" && r.filterType.toUpperCase() != "CAMPAIGN")
  },
  getListOfFiltersNotAllowXml: state => {
    if (state.promptFilterList)
      return state.promptFilterList.filter(r => r.filterType.toUpperCase() != "XML")
  },
};

function getEmptyPrompt() {
  return {
    promptID: 0,
    promptName: '',
    promptTypeID: '',
    promptScript: '',
    subscriptionFilterTypeID: '',
    typeName: '',
    language: 'en-US',
    voice: '',
    speed: '',
    statusID: '',
    statusName: '',
    promptConnectionModels: [],
    duration: 0,
    inputLength: '',
    logicTypeID: '',
    promptParameters: [],
    knownConciergePromptScript: '',
    unKnownConciergePromptScript: ''
  }
}

function getEmptyPromptConnectionModel() {
  return {
    promptConnectionID: 0,
    pressSayIndex: 0,
    promptID: state.promptData.promptID,
    press: '0',
    say: '',
  }
}

function getEmptyPromptParameters() {
  return {
    promptParameterID: 0,
    promptID: state.promptData.promptID,
    promptLogicIndex: 0,
    parameterName: "",
    parameterValue: ""
  }
}

function getDialEmptyPromptParameters() {
  return [
    {
      promptLogicIndex: 0,
      promptParameterID: 0,
      promptID: state.promptData.promptID,
      parameterName: "DialType",
      parameterValue: ""
    },
    {
      promptLogicIndex: 1,
      promptParameterID: 0,
      promptID: state.promptData.promptID,
      parameterName: "Destination",
      parameterValue: ""
    }
  ]
}

function getWebhookEmptyPromptParameters() {
  return [
    { promptLogicIndex: 0, promptParameterID: 0, promptID: state.promptData.promptID, parameterName: "HttpMethod", parameterValue: "POST" },
    { promptLogicIndex: 1, promptParameterID: 0, promptID: state.promptData.promptID, parameterName: "Url", parameterValue: "" },
    { promptLogicIndex: 2, promptParameterID: 0, promptID: state.promptData.promptID, parameterName: "AuthHeaderName", parameterValue: "" },
    { promptLogicIndex: 3, promptParameterID: 0, promptID: state.promptData.promptID, parameterName: "AuthConfigKey", parameterValue: "" },
    { promptLogicIndex: 4, promptParameterID: 0, promptID: state.promptData.promptID, parameterName: "TimeoutMs", parameterValue: "5000" },
    { promptLogicIndex: 5, promptParameterID: 0, promptID: state.promptData.promptID, parameterName: "Payload", parameterValue: "" }
  ]
}




